import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const getDetailIcon = key => {
  const k = (key || '').toLowerCase();
  if (k.includes('size')) {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={css.detailIcon}>
        <path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.4 2.4 0 0 1 0-3.4l2.6-2.6a2.4 2.4 0 0 1 3.4 0z"/>
        <line x1="14.5" y1="12.5" x2="17" y2="15"/>
        <line x1="11.5" y1="9.5" x2="14" y2="12"/>
        <line x1="8.5" y1="6.5" x2="11" y2="9"/>
      </svg>
    );
  }
  if (k.includes('condition')) {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={css.detailIcon}>
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    );
  }
  if (k.includes('color')) {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={css.detailIcon}>
        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
      </svg>
    );
  }
  // Default: Tag / Category / Brand icon
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={css.detailIcon}>
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
      <line x1="7" y1="7" x2="7.01" y2="7"/>
    </svg>
  );
};

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory ? isFieldForCategory(config) : true;

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue !== 'undefined' ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined' && value !== null) {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = val =>
        val
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      const displayValue =
        schemaType === 'enum'
          ? optionConfig?.label || value
          : schemaType === 'boolean'
          ? getBooleanMessage(value)
          : value;

      return filteredConfigs.concat({ key, value: displayValue, label });
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  // Fallback details if publicData fields are not in listingFieldConfigs
  const fallbackDetails = [];
  if (publicData.category && !existingListingFields.some(f => f.key === 'category')) {
    fallbackDetails.push({ key: 'category', value: publicData.category });
  }
  if (publicData.brand && !existingListingFields.some(f => f.key === 'brand')) {
    fallbackDetails.push({ key: 'brand', value: publicData.brand });
  }
  const sz = publicData.size || publicData.clothingSize || publicData.shoeSize || publicData.itemSize;
  if (sz && !existingListingFields.some(f => f.key.toLowerCase().includes('size'))) {
    fallbackDetails.push({ key: 'size', value: typeof sz === 'object' ? sz.label || sz.option : sz });
  }
  const cond = publicData.condition || publicData.itemCondition;
  if (cond && !existingListingFields.some(f => f.key.toLowerCase().includes('condition'))) {
    fallbackDetails.push({ key: 'condition', value: typeof cond === 'object' ? cond.label || cond.option : cond });
  }
  const col = publicData.color || publicData.itemColor;
  if (col && !existingListingFields.some(f => f.key.toLowerCase().includes('color'))) {
    fallbackDetails.push({ key: 'color', value: typeof col === 'object' ? col.label || col.option : col });
  }

  const allDetails = [...existingListingFields, ...fallbackDetails];

  return allDetails.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" defaultMessage="DETAILS" />
      </Heading>
      <ul className={css.details}>
        {allDetails.map(detail => (
          <li key={detail.key} className={css.detailsPill}>
            {getDetailIcon(detail.key)}
            <span className={css.detailValue}>{detail.value}</span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
